import styles from "./YulqoMark.module.css";

type YulqoMarkProps = {
  size?: number;
  spinning?: boolean;
  className?: string;
  title?: string;
};

const YulqoMark: React.FC<YulqoMarkProps> = ({
  size = 38,
  spinning = false,
  className = "",
  title,
}) => {
  const spinClass = spinning ? styles.spin : "";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width={size}
      height={size}
      fill="none"
      className={`${styles.mark} ${spinClass} ${className}`.trim()}
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <rect width="40" height="40" rx="13" fill="#D9774B" />
      <circle cx="15" cy="17" r="2" fill="#FBF4EA" />
      <circle cx="25" cy="17" r="2" fill="#FBF4EA" />
      <path
        d="M13.5 23.5c3.4 3.4 9.6 3.4 13 0"
        stroke="#FBF4EA"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <circle className={styles.dot} cx="31" cy="9" r="4" fill="#F4C95D" />
    </svg>
  );
};

export default YulqoMark;
